import { Stack, Typography } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

type OriginVariant = 'user' | 'group';

interface OriginColumnHeaderProps {
  variant?: OriginVariant;
}

interface OriginTooltipEntry {
  label: string;
  description: string;
}

const getOriginTooltipEntries = (variant: OriginVariant, translation: Translation): OriginTooltipEntry[] => {
  if (variant === 'group') {
    return [
      {
        label: translation.entra_id,
        description: translation.group_origin_entra_tooltip
      },
      {
        label: translation.atlas,
        description: translation.group_origin_manual_hint
      },
      {
        label: translation.preset,
        description: translation.group_is_a_preset_and_has_limited_editing_capabilities
      }
    ];
  }
  return [
    {
      label: translation.entra_id,
      description: translation.user_origin_entra_tooltip
    },
    {
      label: translation.atlas,
      description: translation.user_origin_manual_hint
    },
    {
      label: translation.key_sharing,
      description: translation.user_origin_key_manager_hint
    }
  ];
};

export const OriginColumnHeader: React.FC<OriginColumnHeaderProps> = ({ variant = 'user' }) => {
  const { translation } = useTranslation();
  const entries = getOriginTooltipEntries(variant, translation);
  return (
    <ColumnHeaderWithTooltip
      label={translation.origin}
      tooltip={
        <Stack spacing={1}>
          {entries.map((entry) => (
            <Stack key={entry.label}>
              <Typography variant="caption">
                <strong>{entry.label}:</strong>
              </Typography>
              <Typography variant="caption">{entry.description}</Typography>
            </Stack>
          ))}
        </Stack>
      }
    />
  );
};
